import { useCallback } from 'react';
import useAxios from 'axios-hooks';
import {
  TransportCloudFormPayload,
  TransportCloudParams,
} from './transportCloud.types';

export const useCreateTransportCloudEntry = () => {
  const [{ data, loading }, createTransportCloudEntryReq] = useAxios({
    method: 'POST',
  });

  const createTransportCloudEntry = useCallback(
    (payload: TransportCloudFormPayload) =>
      createTransportCloudEntryReq({
        url: '/backend/service/shipment-plan/create-with-containers',
        data: payload,
      }),
    [createTransportCloudEntryReq],
  );

  return {
    data: data?.result,
    loading,
    createTransportCloudEntry,
  };
};

export const useGetTransportCloudEntries = () => {
  const [{ data, loading }, getTransportCloudEntriesReq] = useAxios({
    method: 'GET',
  });

  const getTransportCloudEntries = useCallback(
    (params: TransportCloudParams) =>
      getTransportCloudEntriesReq({
        url: '/backend/service/job/entry/container/cloud-transport',
        params,
      }),
    [getTransportCloudEntriesReq],
  );

  return {
    data: data?.result,
    loading,
    getTransportCloudEntries,
  };
};
